import { downloadFile } from './downloadFile'

export const downloadTextFile = ({
  textContent,
  filename = 'download.txt',
  mimetype = 'text/plain',
}: {
  textContent: string
  filename: string
  mimetype: string
}) => {
  downloadFile({
    blob: new Blob([textContent], {
      type: mimetype,
    }),
    filename,
  })
}
